import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectCallbackPhone = (state: IApplicationState) => {
  const { builderInfo, phone } = selectNewbuilding(state);
  const callbackPhone = (builderInfo && builderInfo.phone) || phone;

  return callbackPhone ? `+${callbackPhone}` : null;
};
